import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { X_STACK_GUI_FIELDS } from "./XStack.settings";

const { Général: GEN, Placements, ...REST } = X_STACK_GUI_FIELDS;

export const X_GRID_GUI_FIELDS: TXGUISection = {
  Général: [
    ...(GEN ?? []),
    {
      type: "select_option",
      name: "columns",
      label: "Colones",
      options: [
        { value: 1, label: "1 Colone" },
        { value: 2, label: "2 Colones" },
        { value: 3, label: "3 Colones" },
        { value: 4, label: "4 Colones" },
        { value: 5, label: "5 Colones" },
        { value: 6, label: "6 Colones" },
        { value: 7, label: "7 Colones" },
        { value: 8, label: "8 Colones" },
      ],
      defaultValue: 3,
    },
    // {
    //   type: "number",
    //   name: "pageLimit",
    //   label: "Elements Maximum",
    // },
  ],
  ...REST,
};
